(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dk-catalog"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dk-catalog]').forEach((root) => {
    if (root.dataset.ready) return; root.dataset.ready = 'true'; root.classList.add('is-enhanced');
    const form = root.querySelector('[data-dk-refine]');
    const priceMatch = (code, amount, family) => {
      if (!code) return true;
      if (!amount) return false;
      if (code.startsWith('d') && family !== 'deri') return false;
      if (code.startsWith('t') && family !== 'lake') return false;
      if (code.startsWith('m') && family !== 'mucevher') return false;
      if (code === 'd1') return amount <= 160000;
      if (code === 'd2') return amount > 160000 && amount <= 220000;
      if (code === 'd3') return amount > 220000;
      if (code === 't1') return amount <= 1200000;
      if (code === 't2') return amount > 1200000 && amount < 2300000;
      if (code === 't3') return amount >= 2300000;
      if (code === 'm1') return amount < 3000000;
      if (code === 'm2') return amount >= 3000000;
      return true;
    };
    const groupMatch = (groups, card) => {
      if (!groups.length) return true;
      const tags = (card.dataset.dkTags || '').split(/\s+/);
      const name = card.dataset.dkName || '';
      return groups.some((value) => {
        if (value === 'cek-2') return name.includes('2 Çekmeceli');
        if (value === 'cek-3') return name.includes('3 Çekmeceli');
        if (value === 'cek-4') return name.includes('4 Çekmeceli');
        if (value.startsWith('kap-')) {
          if (tags.includes(value)) return true;
          const count = value.slice(4);
          return [` ${count}'lı`, ` ${count}'li`, ` ${count}’lı`, ` ${count}’li`, ` ${count} Saat`, ` ${count} Bölmeli`].some((pattern) => name.includes(pattern)) || [`${count} Saat`, `${count} Bölmeli`, `${count}'lı`, `${count}'li`].some((pattern) => name.startsWith(pattern));
        }
        return tags.includes(value);
      });
    };
    const paintFilters = () => {
      if (!form) return;
      const groups = [...form.querySelectorAll('input[name="grup"]:checked')].map((field) => field.value);
      const price = form.querySelector('input[name="fiyat"]:checked')?.value || '';
      let count = 0;
      root.querySelectorAll('[data-dk-product]').forEach((card) => {
        const show = groupMatch(groups, card) && priceMatch(price, Number(card.dataset.dkPrice || 0), card.dataset.dkFamily || '');
        card.hidden = !show;
        if (show) count += 1;
      });
      const label = root.querySelector('.dk-result-count');
      if (label) label.textContent = `${count} ürün`;
      const clear = root.querySelector('[data-dk-clear]');
      if (clear) clear.hidden = groups.length === 0 && price === '';
      const active = root.querySelector('[data-dk-active]');
      if (active) {
        active.replaceChildren();
        form.querySelectorAll('input:checked').forEach((field) => {
          const chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'dk-refine__chip';
          chip.textContent = field.closest('label')?.innerText.trim() || field.value;
          chip.addEventListener('click', () => { field.checked = false; applyFilters(); });
          active.append(chip);
        });
        active.hidden = active.childElementCount === 0;
      }
      let empty = root.querySelector('.dk-refine__empty');
      if (count === 0) {
        if (!empty && label) {
          empty = document.createElement('p');
          empty.className = 'dk-refine__empty';
          const clearLink = document.createElement('a');
          clearLink.href = form.action;
          clearLink.textContent = 'Filtreyi temizle';
          empty.append('Bu seçime uyan ürün yok. ', clearLink);
          label.insertAdjacentElement('afterend', empty);
        }
      } else if (empty) {
        empty.remove();
      }
      root.removeAttribute('data-dk-filter-pending');
    };
    const params = new URL(location.href).searchParams;
    if (form && (params.has('grup') || params.has('fiyat'))) {
      const groups = params.getAll('grup');
      form.querySelectorAll('input[name="grup"]').forEach((field) => { field.checked = groups.includes(field.value); });
      const price = params.get('fiyat');
      form.querySelectorAll('input[name="fiyat"]').forEach((field) => { field.checked = field.value === price; });
    }
    paintFilters();
    const applyFilters = () => {
      const url = new URL(form.action, location.origin);
      const sort = new URL(location.href).searchParams.get('sort_by');
      if (sort && sort !== 'manual') url.searchParams.set('sort_by', sort);
      form.querySelectorAll('input[name="grup"]:checked').forEach((field) => url.searchParams.append('grup', field.value));
      const price = form.querySelector('input[name="fiyat"]:checked');
      if (price) url.searchParams.set('fiyat', price.value);
      location.assign(url);
    };
    form?.addEventListener('change', (event) => { if (event.target.matches('[data-dk-sort]')) return; applyFilters(); });
    form?.addEventListener('submit', (event) => { event.preventDefault(); applyFilters(); });
    root.querySelector('[data-dk-sort]')?.addEventListener('change', (event) => { const url = new URL(location.href); url.searchParams.set('sort_by', event.currentTarget.value); location.assign(url); });
    const grid = root.querySelector('[data-dk-grid]'); const sentinel = root.querySelector('[data-dk-sentinel]'); let next = root.querySelector('[data-dk-next]'); let loading = false;
    if (!grid || !sentinel || !next) return;
    const load = async () => { if (loading || !next) return; loading = true; try { const url = new URL(next.href); url.searchParams.set('section_id', root.closest('.shopify-section').id.replace('shopify-section-','')); const response = await fetch(url); if (!response.ok) throw new Error(); const page = new DOMParser().parseFromString(await response.text(),'text/html'); page.querySelectorAll('[data-dk-product]').forEach((card) => grid.append(card)); document.dispatchEvent(new Event('dk:content')); const incoming = page.querySelector('[data-dk-next]'); if (incoming) next.href = incoming.href; else { next = null; observer.disconnect(); root.querySelector('.dk-load')?.remove(); } } catch { root.classList.remove('is-enhanced'); observer.disconnect(); } finally { loading = false; } };
    const observer = new IntersectionObserver((entries) => { if (entries[0].isIntersecting) load(); }, {rootMargin:'900px 0px'}); observer.observe(sentinel);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sweb-catalog"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sweb-catalog]').forEach((root) => {
    if (root.dataset.ready) return; root.dataset.ready = 'true'; root.classList.add('is-enhanced');
    const form = root.querySelector('[data-sweb-refine]');
    const priceMatch = (code, amount, family) => {
      if (!code) return true;
      if (!amount) return false;
      if (code.startsWith('d') && family !== 'deri') return false;
      if (code.startsWith('t') && family !== 'lake') return false;
      if (code.startsWith('m') && family !== 'mucevher') return false;
      if (code === 'd1') return amount <= 160000;
      if (code === 'd2') return amount > 160000 && amount <= 220000;
      if (code === 'd3') return amount > 220000;
      if (code === 't1') return amount <= 1200000;
      if (code === 't2') return amount > 1200000 && amount < 2300000;
      if (code === 't3') return amount >= 2300000;
      if (code === 'm1') return amount < 3000000;
      if (code === 'm2') return amount >= 3000000;
      return true;
    };
    const groupMatch = (groups, card) => {
      if (!groups.length) return true;
      const tags = (card.dataset.swebTags || '').split(/\s+/);
      const name = card.dataset.swebName || '';
      return groups.some((value) => {
        if (value === 'cek-2') return name.includes('2 Çekmeceli');
        if (value === 'cek-3') return name.includes('3 Çekmeceli');
        if (value === 'cek-4') return name.includes('4 Çekmeceli');
        if (value.startsWith('kap-')) {
          if (tags.includes(value)) return true;
          const count = value.slice(4);
          return [` ${count}'lı`, ` ${count}'li`, ` ${count}’lı`, ` ${count}’li`, ` ${count} Saat`, ` ${count} Bölmeli`].some((pattern) => name.includes(pattern)) || [`${count} Saat`, `${count} Bölmeli`, `${count}'lı`, `${count}'li`].some((pattern) => name.startsWith(pattern));
        }
        return tags.includes(value);
      });
    };
    const paintFilters = () => {
      if (!form) return;
      const groups = [...form.querySelectorAll('input[name="grup"]:checked')].map((field) => field.value);
      const price = form.querySelector('input[name="fiyat"]:checked')?.value || '';
      let count = 0;
      root.querySelectorAll('[data-sweb-product]').forEach((card) => {
        const show = groupMatch(groups, card) && priceMatch(price, Number(card.dataset.swebPrice || 0), card.dataset.swebFamily || '');
        card.hidden = !show;
        if (show) count += 1;
      });
      const label = root.querySelector('.sweb-result-count');
      if (label) label.textContent = `${count} ürün`;
      const clear = root.querySelector('[data-sweb-clear]');
      if (clear) clear.hidden = groups.length === 0 && price === '';
      const active = root.querySelector('[data-sweb-active]');
      if (active) {
        active.replaceChildren();
        form.querySelectorAll('input:checked').forEach((field) => {
          const chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'sweb-refine__chip';
          chip.textContent = field.closest('label')?.innerText.trim() || field.value;
          chip.addEventListener('click', () => { field.checked = false; applyFilters(); });
          active.append(chip);
        });
        active.hidden = active.childElementCount === 0;
      }
      let empty = root.querySelector('.sweb-refine__empty');
      if (count === 0) {
        if (!empty && label) {
          empty = document.createElement('p');
          empty.className = 'sweb-refine__empty';
          const clearLink = document.createElement('a');
          clearLink.href = form.action;
          clearLink.textContent = 'Filtreyi temizle';
          empty.append('Bu seçime uyan ürün yok. ', clearLink);
          label.insertAdjacentElement('afterend', empty);
        }
      } else if (empty) {
        empty.remove();
      }
      root.removeAttribute('data-sweb-filter-pending');
    };
    const params = new URL(location.href).searchParams;
    if (form && (params.has('grup') || params.has('fiyat'))) {
      const groups = params.getAll('grup');
      form.querySelectorAll('input[name="grup"]').forEach((field) => { field.checked = groups.includes(field.value); });
      const price = params.get('fiyat');
      form.querySelectorAll('input[name="fiyat"]').forEach((field) => { field.checked = field.value === price; });
    }
    paintFilters();
    const applyFilters = () => {
      const url = new URL(form.action, location.origin);
      const sort = new URL(location.href).searchParams.get('sort_by');
      if (sort && sort !== 'manual') url.searchParams.set('sort_by', sort);
      form.querySelectorAll('input[name="grup"]:checked').forEach((field) => url.searchParams.append('grup', field.value));
      const price = form.querySelector('input[name="fiyat"]:checked');
      if (price) url.searchParams.set('fiyat', price.value);
      location.assign(url);
    };
    form?.addEventListener('change', (event) => { if (event.target.matches('[data-sweb-sort]')) return; applyFilters(); });
    form?.addEventListener('submit', (event) => { event.preventDefault(); applyFilters(); });
    root.querySelector('[data-sweb-sort]')?.addEventListener('change', (event) => { const url = new URL(location.href); url.searchParams.set('sort_by', event.currentTarget.value); location.assign(url); });
    const grid = root.querySelector('[data-sweb-grid]'); const sentinel = root.querySelector('[data-sweb-sentinel]'); let next = root.querySelector('[data-sweb-next]'); let loading = false;
    if (!grid || !sentinel || !next) return;
    const load = async () => { if (loading || !next) return; loading = true; try { const url = new URL(next.href); url.searchParams.set('section_id', root.closest('.shopify-section').id.replace('shopify-section-','')); const response = await fetch(url); if (!response.ok) throw new Error(); const page = new DOMParser().parseFromString(await response.text(),'text/html'); page.querySelectorAll('[data-sweb-product]').forEach((card) => grid.append(card)); document.dispatchEvent(new Event('sweb:content')); const incoming = page.querySelector('[data-sweb-next]'); if (incoming) next.href = incoming.href; else { next = null; observer.disconnect(); root.querySelector('.sweb-load')?.remove(); } } catch { root.classList.remove('is-enhanced'); observer.disconnect(); } finally { loading = false; } };
    const observer = new IntersectionObserver((entries) => { if (entries[0].isIntersecting) load(); }, {rootMargin:'900px 0px'}); observer.observe(sentinel);
  });

  } catch(e) { console.error(e); }
})();
})();
